import { useEffect } from "react";
import { useLocation } from "react-router-dom";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/**
 * Envía un page_view a GA4 en cada cambio de ruta del SPA.
 * La carga inicial ya la reporta gtag.js desde index.html.
 */
export function GaRouteTracker() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag !== "function") return;
    const page_path = `${location.pathname}${location.search}${location.hash}`;
    window.gtag("event", "page_view", {
      page_path,
      page_location: window.location.href,
      page_title: document.title,
    });
  }, [location.pathname, location.search, location.hash]);

  return null;
}

export default GaRouteTracker;
